import { Currency, OperationType } from '../domain/transaction';

export class Formatter {

  static toCurrency(value: number | bigint, currency: Currency): string {
    return value.toLocaleString('es-MX', {
      style: 'currency',
      currency: 'MXN',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      currencyDisplay: 'symbol',
      useGrouping: true,
    });
  }

  static toDate(date: string | Date): {dateString: string, timeString: string, date: Date, toShortDate: string } {
    let parsedDate: Date;

    if (typeof date === 'string') {
      parsedDate = new Date(date);
    } else {
      parsedDate = date;
    }

    const dateString = parsedDate.toLocaleDateString('es-MX', {
      day: '2-digit',
      month: '2-digit',
      year: '2-digit'
    })

    const timeString = parsedDate.toLocaleTimeString(undefined, {
      hour12: false,
      minute: '2-digit',
      hour: '2-digit',
    });

    const toShortDate = parsedDate.toLocaleDateString('es-MX', {
      day: '2-digit',
      month: 'short',
      year: '2-digit',
    }).replace('.', '').replace(/\b\w/g, c => c.toUpperCase());

    return {
      date: parsedDate,
      dateString,
      timeString,
      toShortDate,
    };
  }

  static typeToString(type: OperationType): string {
    if  (type === OperationType.payment) {
      return 'pago';
    } else if (type === OperationType.refund) {
      return 'devolución';
    } else if (type === OperationType.annulment) {
      return 'anulación';
    } else {
      return type
    }
  }
}
